export type userRoleType = 'admin' | 'user';

export interface UserInfoInterface {
  email: string;
  emailVerifiedYn?: string;
  isSignupComplete: 'Y' | 'N';
  memberId: string;
  password?: string;
  profileImageUrl?: string;
  providerType?: string;
  registerDatetime?: number[];
  serviceCode: string;
  userId: string;
  userName: string;
  userRole: userRoleType;
  teamName?: string;
  subAccount?: subAccountType[];
  phoneNumber: string;
  phoneNumber1: string;
}

export type subAccountType = {
  teamName: string;
  teamId: string;
  email: string;
};

// fetchmyApp, CompetitorApps Request Params
export type fetchAppInfoParamsType = subAccountType & {
  userId: string;
  // 국가및 언어 선택
  country: string;
  language: string;
};
// fetchCompetitor'sAppsList Request Params
export type fetchCompetitorAppsParamsType = {
  userId: string;
  appId: string;
  provider_type: string;
  // 국가및 언어 선택
  country: string;
  language: string;
};

export const accountMenu = {
  account: 'account',
  team: 'team',
  payment: 'payment',
  plan: 'plan',
};

export const accountMenuArray = [
  { name: 'account', text: 'Account Manager' },
  { name: 'team', text: 'Team Manager' },
  { name: 'payment', text: 'Payment Manager' },
  { name: 'plan', text: 'Plan & Upgrade' },
];

export interface ILogInForm {
  email: string;
  password: string;
}

export enum LogInType {
  aix = 'aix',
  google = 'google',
  facebook = 'facebook',
}

// 로그인 요청 params
export interface ILogInReqParams {
  type: LogInType;
  email?: string;
  password?: string;
}

// 회원가입 추가 정보 입력 params
export interface ISignUpEmail {
  email: string;
  password: string;
  userName: string;
  corporateName: string;
  jobTitle: string;
  phoneNumber: string;
}

// SNS 회원 가입 추가 정보 입력 params
export interface ISignUpSNS {
  email: string;
  snsType: LogInType;
  userName: string;
  corporateName: string;
  jobTitle: string;
  phoneNumber: string;
}
